import '../App.css';
import styles from '../assets/styles/home.module.css'
import React, { useState, useEffect, useMemo } from 'react';
import EventAutocomplete from '../components/Eventinput';
import {
    logout,
    signIn,
    signInWithEmail,
    isTeamVerified,
    isAdmin
} from "../lib/firebase";
import { OFFLINE_COPY } from '../lib/offline';
import { downloadOfflineCopy } from '../lib/offlineDownload';
import {getDataArray, masterConfig, nonUploadedData, gamemodes, elimsPositions} from '../configs/generalConfig';
import versionInfo from '../version.json';
import searchImg from '../assets/images/search.png';
import settingsImg from '../assets/images/settings.png';
import infoImg from '../assets/images/info.png';
import cardImg from '../assets/images/cards.png';
import relayImg from '../assets/images/relay.png';
import Wifi from '../components/Wifi';
import OctopusStatus from '../components/OctopusStatus';
import Toast from "../lib/toast";
import { useDeviceInfo, getIfPWAInstalled } from '../lib/mobile';
import { autofillAccountInfo, resetPassword } from "../lib/firebase";

const OSPREY_VERSION = versionInfo.version;


function Home({currentTab, setUser, setCurrentTab, authentication, setAuthentication, setInitialDataMap, initialDataMap, eventPath, setEventPath, funnySounds, sfxEnabled, eventList, setEventList, settingsYear, setGameMode, gamemode}) {
    const { device } = useDeviceInfo();
    const [showInfo, setShowInfo] = useState(true);

    const [showEmailModal, setShowEmailModal] = useState(false);
    const [emailInput, setEmailInput] = useState("");
    const [resetEmailInput, setResetEmailInput] = useState("");
    const [pwdInput, setPwdInput] = useState("");

    const initialPage = useMemo(() => (
        {...masterConfig[settingsYear].initialPage}
    ), [settingsYear, gamemode]);

    const thisInitialDataMap = useMemo(() => {
        const map = new Map();
        for (const key in initialPage) {
            map.set(key, "");
        }
        return map;
    }, [initialPage]);

    useEffect(() => {
        let newMap = new Map();
        const updated = getDataArray(settingsYear);
        for (const [key, value] of updated) {
            newMap.set(key, value);
        }
        const preserve = ["scout_id", "scout_team", "alliance_color", "team_position"];
        preserve.forEach(key => {
            const existing = initialDataMap.get(key);
            if (existing !== undefined && existing !== "" && existing !== 0) {
                newMap.set(key, existing);
            }
        });
        setInitialDataMap(newMap);
        if (authentication && authentication !== false) {
            autofillAccountInfo(authentication, setUser, setAuthentication).then(data => {
                if (!data) return;
                if (data.scout_id !== "") handleChange("scout_id", data.scout_id, initialPage["scout_id"].writeType);
                if (data.scout_team !== "") handleChange("scout_team", data.scout_team, initialPage["scout_team"].writeType);
            });
        }
    }, [settingsYear, gamemode]);

    function switchTab(target) {
        setCurrentTab(String(target).toLowerCase());
    }

    const handleChange = (key, value, writeType, max = 13000) => {
        if (writeType === "int") {
            if (String(value).length > 0 && ((!/^\d+$/.test(String(value))) || parseInt(value) > parseInt(max) || parseInt(value) <= 0)) {
                return;
            }
        } else {
            if (value.length > parseInt(max)) return;
            if (key.includes("event")) {
                setEventPath(value);
                return;
            }
        }
        if (nonUploadedData.indexOf(key) < 0) {
            setInitialDataMap(prev => {
                let tempMap = new Map(prev);
                if (writeType === "int") {
                    tempMap.set(key, parseInt(value));
                } else {
                    tempMap.set(key, value);
                }
                // console.log("Changed " + key + "to " + value);
                return tempMap;
            });
        } else {
            // console.log("Changed " + key + "to " + value + ". Not part of uploadData");
        }
    };

    const [showModal, setShowModal] = useState(false);

    // Admins get the offline copy's download link (scripts/build-offline.js, lib/offline.js)
    const [isAdminUser, setIsAdminUser] = useState(false);
    useEffect(() => {
        if (OFFLINE_COPY || !authentication) {
            setIsAdminUser(false);
            return;
        }
        let live = true;
        isAdmin(authentication).then(admin => { if (live) setIsAdminUser(Boolean(admin)); }, () => {});
        return () => { live = false; };
    }, [authentication]);

    /** The offline copy with this event's TBA team list and schedule built in */
    async function downloadOffline() {
        try {
            const { event, endpoints } = await downloadOfflineCopy(eventPath);
            if (!event) Toast.info("Downloaded offline Osprey with no event built in.");
            else if (endpoints === 0) Toast.error(`Downloaded, but TBA had nothing for ${event}: no team list built in.`);
            else Toast.success(`Downloaded offline Osprey with ${event}'s TBA data.`);
        } catch (err) {
            Toast.error(`Couldn't download the offline copy: ${err && err.message ? err.message : err}`);
        }
    }

    // useEffect(() => {
    //     console.log("initialDataMap updated:", [...initialDataMap.entries()]);
    // }, [initialDataMap]);

    useEffect(() => {
        if (authentication === false) {
            handleChange("scout_id", "", initialPage["scout_id"].writeType);
            handleChange("scout_team", "", initialPage["scout_team"].writeType);
        } else if (authentication) {
            autofillAccountInfo(authentication, setUser, setAuthentication).then(data => {
                if (!data) return;
                if (data.scout_id !== "") handleChange("scout_id", data.scout_id, initialPage["scout_id"].writeType);
                if (data.scout_team !== "") handleChange("scout_team", data.scout_team, initialPage["scout_team"].writeType);
            });
        }
    }, [authentication]);

    async function toScoutPage() {
        for (const [, info] of Object.entries(initialPage)) {
            if (!initialDataMap.has(info.label)) continue;
            let value = initialDataMap.get(info.label);
            if (value === undefined || value === null || String(value).trim() === "") {
                Toast.error("Missing Necessary Inputs: " + info.display, funnySounds, sfxEnabled);
                return;
            } else if (info.writeType === "int" && ((parseInt(value) <= 0) || isNaN(parseInt(value)))) {
                Toast.error("Missing Necessary Inputs: " + info.display, funnySounds, sfxEnabled);
                return;
            }
        }
        const teamNumber = initialDataMap.get("scout_team");
        const verified = await isTeamVerified(authentication, teamNumber);
        console.log(verified)
        if (!verified) {
            Toast.error(`Team ${teamNumber} is not verified.`, funnySounds, sfxEnabled);
            return;
        }
        switchTab("scout");
    }

    function changeEvent() {
        setShowModal(true);
    }

    function closeEmailModal() {
        setShowEmailModal(false);
        setEmailInput("");
        setPwdInput("");
    }

    async function handleEmailSubmit() {
        if (!emailInput || !pwdInput) {
            Toast.error("Please enter both email and password.");
            return;
        }
        const success = await signInWithEmail(emailInput.trim(), pwdInput, setUser, setAuthentication);
        if (success) closeEmailModal();
    }

    async function handlePasswordReset() {
        if (!resetEmailInput) {
            Toast.error("Please enter email.");
            return;
        }
        await resetPassword(resetEmailInput);
    }

    if (currentTab === "home") {
        return (
            <div className={`${styles.Home} subpage`}>
                <div className={styles.titleContainer}>
                    <h1 className={styles.title}>★&nbsp;&nbsp;Osprey&nbsp;&nbsp;★</h1>
                </div>

                {!getIfPWAInstalled() && device !== "desktop" ? (
                    <>
                        <span className={showInfo ? "tint" : "invisible"}></span>
                        <div className={showInfo ? styles.infoPopup : "invisible"}>
                            <span className={styles.subtitleText}>Osprey is currently being run on a browser. To experience the best version of Osprey please download it to your device. The download button can be found in the settings page.</span>
                            <button className={styles.subtitleButton} onClick={() => setShowInfo(false)}>X</button>
                        </div>
                    </>
                ) : (
                    <h2 className="invisible">Thanks for installing our app</h2>
                )}

                {showEmailModal && (
                    <>
                        <span className="tint" onClick={closeEmailModal}></span>
                        <div className={styles.emailModal}>
                            <div className={styles.emailModalHeader}>
                                <span className={styles.emailModalTitle}>Sign In with Email</span>
                                <button className={styles.emailModalClose} onClick={closeEmailModal}>✕</button>
                            </div>
                            <p>Only use if Google Sign-In is blocked on your device.</p>
                            <div className={styles.emailModalFields}>
                                <input
                                    className={`textInput ${styles.emailModalInput}`}
                                    type="email"
                                    placeholder="Email"
                                    value={emailInput}
                                    onChange={e => setEmailInput(e.target.value)}
                                    autoComplete="email"
                                />
                                <input
                                    className={`textInput ${styles.emailModalInput}`}
                                    type="password"
                                    placeholder="Password"
                                    value={pwdInput}
                                    onChange={e => setPwdInput(e.target.value)}
                                    autoComplete="current-password"
                                    onKeyDown={e => { if (e.key === "Enter") handleEmailSubmit(); }}
                                />
                            </div>
                            <button
                                className={`uiButton ${styles.emailModalSubmit}`}
                                onClick={handleEmailSubmit}
                            >
                                Sign In
                            </button>
                            <div className = {styles.emailModalFields}>
                                <p>If you haven't already, Reset Password to initialize Manual Sign In.</p>
                                <input
                                    className={`textInput ${styles.emailModalInput}`}
                                    type="email"
                                    placeholder="Email"
                                    value={resetEmailInput}
                                    onChange={e => setResetEmailInput(e.target.value)}
                                    autoComplete="email"
                                />
                            </div>
                            <button className = {`uiButton ${styles.resetPassword}`} onClick = {handlePasswordReset}>Reset Password</button>
                        </div>
                    </>
                )}

                <div className={styles.configSection}>
                    {[...thisInitialDataMap.entries()].map(([key, value]) => (
                        <div key={key} className={styles.inputSection}>
                            <span className={styles.displayLabel}>{initialPage[key].display}</span>
                            {key === "alliance_color" ? (
                                <div className={styles.allianceCircleDiv}>
                                    <button
                                        className={styles.allianceCircle}
                                        onClick={e => handleChange(key, e.target.value, initialPage[key].writeType)}
                                        value={initialDataMap.get(key) === "r" ? 'b' : 'r'}
                                        style={{
                                            backgroundColor: `${initialDataMap.get(key) === "r" ? 'var(--r)' : (initialDataMap.get(key) === "b" ? 'var(--b)' : "var(--altBgColor)")}`,
                                            borderRadius: `${(initialDataMap.get(key) === "r" || initialDataMap.get(key) === "b") ? '50%' : "var(--borderRadius)"}`,
                                        }}
                                    >
                                        {initialDataMap.get(key) === "r" || initialDataMap.get(key) === "b" ? "" : initialPage[key].placeholder}
                                    </button>
                                </div>
                            ) : key === "event_path" ? (
                                <div className={styles.eventSection}>
                                    <span onClick={() => changeEvent()} className={`${styles.eventPathSection} textInput`}>
                                        {eventPath === "" ? "- - - -" : eventPath}
                                    </span>
                                </div>
                            ) : key === "team_position" && gamemode === 3 ? (
                                <select className="textInput" value={initialDataMap.get("team_position") || ""} onChange={e => {
                                    handleChange("team_position", parseInt(e.target.value), "int");
                                }}>
                                    <option value="" disabled>Select Position</option>
                                    {elimsPositions.map((position, index) => (
                                        <option key={index} value={index + 1}>{position}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    className="textInput"
                                    type={key.includes("id") ? "text" : "number"}
                                    inputMode={key.includes("id") ? "text" : "numeric"}
                                    value={key.includes("event") ? eventPath : initialDataMap.get(key) || ""}
                                    onChange={e => handleChange(key, e.target.value, initialPage[key].writeType, initialPage[key].maxLength)}
                                    placeholder={initialPage[key].placeholder}
                                    maxLength={initialPage[key].maxLength}
                                />
                            )}
                        </div>
                    ))}
                </div>

                <button className={`${styles.scoutButton} uiButton`} onClick={() => toScoutPage()}>
                    Scout Page
                </button>

                {authentication === false ? (
                    <div className={styles.signInGroup}>
                        <button className={`${styles.logButton} ${styles.signIn} uiButton`} onClick={() => {
                            signIn(setUser, setCurrentTab, setAuthentication);
                        }}>Google Sign in</button>
                        <button className={`${styles.logButton} ${styles.signInEmail} uiButton`} onClick={() => {
                            setShowEmailModal(true);
                        }}>Manual Sign in</button>
                    </div>
                ) : (
                    <button className={`${styles.logButton} ${styles.signOut} uiButton`} onClick={() => {
                        logout(setUser, setAuthentication);
                    }}>Sign Out</button>
                )}

                <div className={styles.wifiDiv}>
                    <Wifi />
                    <OctopusStatus eventPath={eventPath} />
                </div>
                <div className={styles.versionNum}>
                    <span>Osprey Version {OSPREY_VERSION || "unknown (contact a Narwhal)"}</span>
                    {OFFLINE_COPY && <span className={styles.offlineNote}>Offline copy · saves here, no Firebase</span>}
                    {isAdminUser && (
                        <button className={styles.offlineDownload} onClick={downloadOffline}>
                            Download offline Osprey ({eventPath || "no event"})
                        </button>
                    )}
                </div>
                <button className={`${styles.infoButton} ${styles.imgBtnContainer}`} onClick={() => switchTab("info")}>
                    <img className={styles.imgBtn} src={infoImg} alt='Info' />
                </button>
                <button className={`${styles.settingsButton} ${styles.imgBtnContainer}`} onClick={() => switchTab("settings")}>
                    <img className={styles.imgBtn} src={settingsImg} alt='Settings' />
                </button>
                <button className={`${styles.searchButton} ${styles.imgBtnContainer}`} onClick={() => switchTab("scanner")}>
                    <img className={styles.imgBtn} src={searchImg} alt='Search' />
                </button>
                <button className={`${styles.cardButton} ${styles.imgBtnContainer}`} onClick={() => switchTab("games")}>
                    <img className={styles.imgBtn} src={cardImg} alt='Game' />
                </button>
                <button className={`${styles.relayButton} ${styles.imgBtnContainer}`} onClick={() => switchTab("relay")}>
                    <img className={styles.imgBtn} src={relayImg} alt='Relay' />
                </button>

                <EventAutocomplete
                    setEventPath={setEventPath}
                    funnySounds={funnySounds}
                    sfxEnabled={sfxEnabled}
                    setShowModal={setShowModal}
                    showModal={showModal}
                    eventPath={eventPath}
                    eventList={eventList}
                    setEventList={setEventList}
                    settingsYear={settingsYear}
                />
            </div>
        );
    }
    else return;
}
export default Home;